import { isEmptyValue } from "./is-empty-value";

export const isEmptyObject = (value: any) => isEmptyValue(value) || Object.keys(value).every((k) => isEmptyValue(value[k]));
